<template>
  <div>
    <Head title="Order details" />
    <h1 class="mb-8 text-3xl font-bold">Order No. {{ order.order_no }}</h1>
    <h3 class="mb-8 text-2xl font-bold">Customer: {{ order.customer }}</h3>
    <div class="mb-3">
      <Link
        :href="`/invoice-validation/delivery-runs/${deliveryRun.id}/details`"
        class="text-orange-600 hover:text-orange-500 mb-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6 inline"
          style="display: inline !important"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
          />
        </svg>
        Back
      </Link>
    </div>
    <div v-if="order.invoiced === true" class="flex items-center justify-between mb-6">
      <a
        class="btn-orange ml-auto"
        href="#"
        @click="openModal"
      >
        Generate Invoice
      </a>
    </div>
    <hr />
    <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
      <table class="w-full whitespace-nowrap" style="width: 100%">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">#</th>
          <th class="pb-3 pt-3 px-3">SKU</th>
          <th class="pb-3 pt-3 px-3">Description</th>
          <th class="pb-3 pt-3 px-3">Qty</th>
          <th class="pb-3 pt-3 px-">Unit Price</th>
          <th class="pb-3 pt-3 px-">Discount (%)</th>
          <th class="pb-3 pt-3 px-3 text-end">Amount</th>
        </tr>
        <tr v-for="(item, index) in details" :key="index">
          <td class="w-px border-t pb-3 pt-3">
            <span class="flex items-center px-3">{{ index + 1 }}</span>
          </td>
          <td class="w-px border-t pb-3 pt-3">
            <span class="flex items-left px-3">{{ item.sku }}</span>
          </td>
          <td class="w-px border-t pb-3 pt-3">
            <span class="flex items-left px-3">{{ item.description }}</span>
          </td>
          <td class="w-px border-t pb-3 pt-3">
            <span class="flex items-center justify-center px-3">{{ item.quantity_packed }}</span>
          </td>
          <td class="w-px border-t pb-3 pt-3">
            <span class="flex items-center justify-center px-3">{{
              item.unit_cost
            }}</span>
          </td>
          <td class="w-px border-t pb-3 pt-3">
            <span class="flex items-center px-3">{{ item.discount_rate }}</span>
          </td>
          <td class="w-px border-t pb-3 pt-3">
            <span class="flex items-end px-3 text-end justify-end">{{
              item.amount_packed
            }}</span>
          </td>
        </tr>
        <tr>
          <td class="w-px border-t pb-3 pt-3 border-dark"></td>
          <td class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3">SubTotal</td>
          <td class="w-px border-t pb-3 pt-3">
            <span class="flex items-end px-3 items-end justify-end">{{
              payments.sub_total
            }}</span>
          </td>
        </tr>
        <tr>
          <td class="w-px border-t pb-3 pt-3"></td>
          <td class="w-px border-t pb-3 pt-3" />
          <th class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3">VAT</td>
          <td class="w-px border-t pb-3 pt-3">
            <span class="flex items-end px-3 items-end justify-end">{{
              payments.vat
            }}</span>
          </td>
        </tr>
        <tr>
          <td class="w-px border-t pb-3 pt-3"></td>
          <td class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3">Total</td>
          <td class="w-px border-t pb-3 pt-3">
            <span class="flex items-end px-3 items-end justify-end">{{
              payments.gross_amount
            }}</span>
          </td>
        </tr>
        <tr>
          <td class="w-px border-t pb-3 pt-3"></td>
          <td class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3">Paid</td>
          <td class="w-px border-t pb-3 pt-3">
            <span class="flex items-end px-3 items-end justify-end">{{
              payments.payment
            }}</span>
          </td>
        </tr>
        <tr>
          <td class="w-px border-t pb-3 pt-3"></td>
          <td class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3" />
          <td class="w-px border-t pb-3 pt-3">Balance</td>
          <td class="w-px border-t pb-3 pt-3">
            <span class="flex items-end px-3 items-end justify-end"
              ><strong>{{ payments.balance }}</strong></span
            >
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div v-if="isOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left shadow-xl transform transition-all sm:my-12 sm:align-middle sm:max-w-lg sm:w-full"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full">
            <h1>Generate Invoice</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <div class="w-full lg:w-full pb-2 pr-6">
                <multiselect
                  id="entity"
                  v-model="form.processing_type"
                  placeholder="Search Processing Type"
                  :options="entities"
                  :close-on-select="true"
                  :searchable="true"
                  :error="$props.errors.processing_type"
                  :style="$props.errors.processing_type ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                />
                <div v-if="$props.errors.processing_type" class="form-error">{{ $props.errors.processing_type }}</div>
              </div>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="submit">
                Generate Invoice
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeModal">
                Cancel
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import Layout from "@/Shared/Layout";
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    Head,
    Link,
    Multiselect,
  },
  layout: Layout,
  props: {
    details: Object,
    errors: Object,
    payments: Array,
    deliveryRun: Object,
    order: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        processing_type: '',
        orderId: this.order.id,
      }),
      entities: [
        {
          label : 'Taxilla',
          value : 'Taxilla',
        },
        {
          label : 'Direct',
          value : 'Direct',
        }
      ],
      isOpen: false,
      processing: false,
    };
  },
  computed: {
    user() {
      return this.$inertia.page.props.auth.user;
    },
  },
  methods: {
    openModal() {
      this.isOpen = true
    },
    closeModal() {
      this.isOpen = false
      this.form.processing_type = null
    },
    submit() {
      this.processing = true;
      this.$inertia.post(
        `/invoice-validation/delivery-runs/${this.deliveryRun.id}/mass-invoice-validation?orderId=${this.order.id}`,
        this.form,
        {
          onSuccess: () => {
            this.processing = false;
          },
        }
      );
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
.multiselect-option.is-selected.is-pointed {
  background: var(--ms-option-bg-selected-pointed, #fb923c);
  color: var(--ms-option-color-selected-pointed, #fff);
}
.multiselect-option.is-selected {
  background: var(--ms-option-bg-selected-pointed, #fb923c);
  color: var(--ms-option-color-selected-pointed, #fff);
}
.modal-wrapper h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 10px;
}
</style>
